import React, { useState, useEffect } from 'react';
import { chunk } from 'utils/chunk';
import { CardGroupContainer } from './styles';

const CardsGroup = (props) => {
  const {
    children,
    cols,
    responsiveMode = 'normal', // normal, twocolumn
  } = props;

  const getCards = () => {
    const cards =
      colLen > 0 && children.length > 0
        ? children.concat(Array(colLen - (children.length % colLen)).fill(null))
        : [];

    return cards;
  };

  const [colLen, setColLen] = useState(cols || children.length);
  const [cardRows, setCardRows] = useState(chunk(getCards(), colLen));

  useEffect(() => {
    if (
      typeof window === 'object' &&
      window.innerWidth <= 767 &&
      (responsiveMode === 'twocolumn' || colLen >= 4)
    ) {
      setColLen(2);
    }
  }, []);

  useEffect(() => {
    const cards = getCards();
    setCardRows(chunk(cards, colLen));
  }, [colLen, children]);

  return (
    <CardGroupContainer
      id="card-group"
      data-testid="card-group"
      role="list"
      responsiveMode={responsiveMode}
    >
      {cardRows.map((row, index) => (
        <div className="card-group--row" key={index}>
          {row.map((item, index1) => (
            <div
              className={`card-group--item${!item ? ' empty-item' : ''}`}
              key={`${index}-${index1}`}
            >
              {item}
            </div>
          ))}
        </div>
      ))}
    </CardGroupContainer>
  );
};

export default CardsGroup;
